import Edit from "./Edit";

const { registerBlockType } = wp.blocks;
import metadata from "./../../../blocks/playlist-extensive/block.json";

if (window.h5apPlayer?.isPipe) {
  registerBlockType(metadata, {
    getEditWrapperProps: () => {
      return {
        className: "h5ap-block-wrapper",
      };
    },
    edit: Edit,
  });
}
